import React from "react";

export function SplashScreen({
    getLocalization,
}: {
    getLocalization: (id: string) => string;
}) {
    const [visible, setVisible] = React.useState<boolean>(true);

    if (!visible) {
        return null;
    }

    return (
        <div
            className="splash-screen"
            onClick={() => {
                setVisible(false);
            }}
        >
            <div className="zigzag" />
            <div className="zigzag-reverse" />
            <div className="background" />
            <div className="wrapper">
                <div className="bubble" />
                <div className="text">
                    {getLocalization(
                        "globalText.langVelvetGlitchFinalQuestion",
                    )}
                </div>
                <div className="instructions">
                    {getLocalization(
                        "globalText.langVelvetGlitchFinalQuestionInstruction",
                    )}
                </div>
            </div>
        </div>
    );
}
